// This file is autogenerated from the values exported from Figma
// DO NOT MODIFY BUT ONLY UPDATE BY RUNNING THE GENERATION SCRIPT.

import localFont from 'next/font/local';

export const theSansC5s = localFont({
	src: [
		{
			path: './font/TheSansC5s-Bold.woff2',
			weight: '700',
			style: 'normal',
		},
		{
			path: './font/TheSansC5s-SemiBold.woff2',
			weight: '600',
			style: 'normal',
		},
		{
			path: './font/TheSansC5s-SemiBoldItalic.woff2',
			weight: '600',
			style: 'italic',
		},
		{
			path: './font/TheSansC5s-Plain.woff2',
			weight: '400',
			style: 'normal',
		},
		{
			path: './font/TheSansC5s-PlainItalic.woff2',
			weight: '400',
			style: 'italic',
		},
		{
			path: './font/TheSansC5s-SemiLight.woff2',
			weight: '350',
			style: 'normal',
		},
	],
	fallback: ['Helvetica Neue', 'Helvetica', 'Arial', 'Verdana', 'Tahoma', 'sans-serif'],
	display: 'swap',
	variable: '--font-family',
});
